//
//
//
//
//

import { getProvinceSelector } from '@/api/system/province';
export default {
  name: 'Weforsys-Address',
  props: ["value", "level"],
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function data() {
    var that = this;
    return {
      options: [],
      props: {
        lazy: true,
        value: 'value',
        label: 'label',
        children: 'children',
        leaf: 'leaf',
        lazyLoad: function lazyLoad(node, resolve) {
          var data = node.data,
            level = node.level;
          var id = level === 0 ? -1 : data.value;
          getProvinceSelector(id).then(function (res) {
            var list = res.data.list.map(function (value, i) {
              return {
                value: value.id,
                label: value.fullName,
                leaf: level >= that.level ? true : value.isLeaf
              };
            });
            resolve(list);
          });
        }
      },
      innerValue: this.value
    };
  },
  methods: {},
  created: function created() {},
  watch: {
    innerValue: function innerValue(val) {
      val && this.$emit('change', val);
    },
    value: function value(val) {
      this.innerValue = val;
    }
  }
};